import APIError from 'exceptions/APIError';
import { getFeatureToggleFetcher } from 'fetchers/featureToggle.fetchers';
import { FeatureToggles } from 'interfaces/FeatureToggle.interface';

export const getFeatureToggle = async (
  orgSlug: string,
  keys: string[],
): Promise<FeatureToggles> => {
  try {
    const data = await getFeatureToggleFetcher(orgSlug, keys);

    return FeatureToggles.fromApiData(data);
  } catch (error) {
    throw new APIError(error.message);
  }
};
